import { cardClassName } from "@/modules/utils/dashboard/constants";
import { useClientTranslations } from "@/lib/translate";

export const DashboardEmptyState = () => {
  const { t } = useClientTranslations("dashboard-page");

  return (
    <section className={`${cardClassName} py-14 text-center`}>
      <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
        {t("dashboard.emptyState.title")}
      </h2>
      <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
        {t("dashboard.emptyState.description")}
      </p>
    </section>
  );
};
